import React from 'react';
import Counter from '../Counter';

export default function Card({ cardDetails }) {
  const { icon, prefix = '', suffix = '', value, title, tooltip } = cardDetails;
  return (
    <div className="python-stats-card">
      {icon}
      <div className="py-stats-info">
        <h4>
          {prefix}
          <Counter end={value} start={1} duration={3} />
          {suffix}
        </h4>
        <p>{title}</p>
      </div>
    </div>
  );
}
